import React from 'react';

import "./index.css";


function ErrorMessage(props) {
    return (<div class='error-message'>{props.children}</div>);
}

export default  ErrorMessage;
